import { ICalendarDayForPersonType } from '../../../../interfaces/BookingRelatesInterfaces';
import availabilityDateColors from '../../../../constans/availabilityDateColors';

const dayIsAvailable = (day?: ICalendarDayForPersonType) =>
  day &&
  availabilityDateColors.includes(day.availability) &&
  day.price !== null;

export default dayIsAvailable;
